

import axios from 'axios';
import { AllContent } from '../types';

const API_URL = import.meta.env.VITE_API_URL || 'http://0.0.0.0:8055';

interface FetchFilteredAllContentProps {
  pageParam: number;
  categoryId: string | null;
  subcategoryIds: string[];
  filters: any;
  selectedYears: number[];
  limit?: number;
}


export const fetchFilteredAllContent = async ({
  pageParam = 1,
  categoryId,
  subcategoryIds,
  filters,
  limit = 200,
}: FetchFilteredAllContentProps): Promise<{
  data: AllContent[];
  nextPage: number | undefined;
  totalItems: number;
}> => {
  let params: any = {
    fields: [
      'id',
      'date_created',
      'translations.*',
      'archive_status',

      'archive',
      'important',
      'years',
      'years.years_id.year',
      'cover',
      'category.id',
      'category.translations.*',
      'category.slug',
      'subcategories.subcategories_id',
      'subcategories.subcategories_id.translations.*',
      'subcategories.translations.*',
      'tags.tags_id.translations.*',
      'tags.tags_id',
      'tags.translations.*',
      'slug',
    ],
    meta: '*',
    sort: ['-years.years_id.year'], 
    page: pageParam,
  };

 const filterConditions = [];

  if (categoryId) {
    filterConditions.push({
      category: {
        id: {
          _eq: categoryId,
        },
      },
    });
  }

  if (subcategoryIds.length > 0) {
    filterConditions.push({
      subcategories: {
        subcategories_id: {
          _in: subcategoryIds,
        },
      },
    });
  }

  if (filters) {
    if (filters.archiveStatus === 'current') {
      filterConditions.push({ archive: { _null: true } });
    } else if (filters.archiveStatus === 'archive') {
      filterConditions.push({ archive: { _nnull: true } });
    }

    const activeTagIds = Object.entries(filters)
      .filter(([key, value]) => key !== 'archiveStatus' && value)
      .map(([key]) => key);

    if (activeTagIds.length > 0) {
      filterConditions.push({
        tags: {
          tags_id: {
            id: {
              _in: activeTagIds,
            },
          },
        },
      });
    }
  }

  if (filterConditions.length > 0) {
    params.filter = {
      _and: filterConditions,
    };
  }

  try {
    const response = await axios.get(`${API_URL}/items/allContent`, {
      params,
    });

    return {
      data: response.data.data,
      nextPage: response.data.data.length === limit ? pageParam + 1 : undefined,
      totalItems: response.data.meta?.total_count || response.data.data.length,
    };
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};
